export const dashboard = {
  title: "Tableau de bord",
  filters: {
    accommodation: "Hébergement",
    allAccommodations: "Tous les hébergements",
    period: "Période",
    periodOptions: {
      today: "Aujourd'hui",
      week: "Semaine",
      month: "Mois",
      year: "Année",
    },
  },
  actions: {
    createBooking: "Créer une réservation",
  },
  pendingWidget: {
    title: "Actions en attente",
    subtitle: "Paiements, demandes et chambres à attribuer.",
    oneRequest: "demande",
    manyRequests: "demandes",
    onePayment: "paiement",
    manyPayments: "paiements",
    oneUnassigned: "à attribuer",
    manyUnassigned: "à attribuer",
    loading: "Chargement des actions en attente...",
    emptyTitle: "Aucune action en attente",
    emptyText: "Lorsqu'une nouvelle demande arrive ou qu'une réservation est en attente de paiement, elle apparaît ici.",
    noName: "Sans nom",
    accommodation: "Hébergement",
    guest: "client",
    guests: "clients",
    requestShort: "Demande",
    pendingPaymentShort: "En attente de paiement",
    unassignedShort: "Attribuer une chambre",
    approve: "Approuver",
    reject: "Refuser",
    viewAll: "Voir toutes les réservations",
    modalApproveTitle: "Approuver la demande",
    modalRejectTitle: "Refuser la demande",
    modalApproveText1: "Vous êtes sur le point d'approuver la demande de",
    modalApproveText2: "Si cette réservation utilise le paiement en ligne, elle passera en attente de paiement.",
    modalRejectText1: "Vous êtes sur le point de refuser la demande de",
    modalRejectText2: "Vous pouvez indiquer un motif à envoyer au client par e-mail.",
    rejectReasonLabel: "Motif du refus",
    rejectReasonPlaceholder: "Sélectionnez un motif",
    reasonDatesUnavailable: "Les dates ne sont plus disponibles",
    reasonPriceUnavailable: "Le tarif n'est plus disponible",
    reasonMinimumStay: "Ne respecte pas le séjour minimum",
    reasonHouseRules: "Ne respecte pas les règles de l'hébergement",
    reasonOther: "Autre motif",
    rejectReasonOtherPlaceholder: "Indiquez le motif du refus",
    rejectReasonRequired: "Vous devez sélectionner un motif de refus.",
    rejectReasonOtherRequired: "Vous devez indiquer le motif du refus.",
    cancel: "Annuler",
    confirmApprove: "Oui, approuver",
    confirmReject: "Oui, refuser",
    statusUpdatedSuccess: "Statut mis à jour avec succès.",
    statusUpdatedError: "Impossible de mettre à jour le statut."
  },

  stats: {
    totalReservations: {
      today:   "Réservations aujourd'hui",
      week:    "Réservations cette semaine",
      month:   "Réservations ce mois-ci",
      year:    "Réservations cette année",
      default: "Total des réservations",
    },
    checkIns: {
      today:   "Check-ins aujourd'hui",
      week:    "Check-ins cette semaine",
      month:   "Check-ins ce mois-ci",
      year:    "Check-ins cette année",
      default: "Check-ins",
    },
    occupancy: {
      today:   "Occupation aujourd'hui",
      week:    "Occupation hebdomadaire",
      month:   "Occupation mensuelle",
      year:    "Occupation annuelle",
      default: "Occupation",
    },
    revenue: {
      today:   "Revenus du jour",
      week:    "Revenus hebdomadaires",
      month:   "Revenus mensuels",
      year:    "Revenus annuels",
      default: "Revenus",
    },
  },
  section3: {
    title: "Réservations à venir",
    subtitle: "Liste des prochaines arrivées de votre hébergement",
    timeFilters: {
      upcoming: "À venir",
      thisWeek: "Cette semaine",
      today: "Aujourd'hui",
      tomorrow: "Demain",
      month: "Mois",
    },
    table: {
      headers: {
        responsible: "Responsable",
        checkInDate: "Date du check-in",
        entry: "Entrée",
        guests: "Clients",
        status: "Statut",
      },
    },
    empty: {
      today: {
        title: "Vous n'avez aucune arrivée aujourd'hui",
        description:
          "Lorsqu'une nouvelle arrivée sera prévue pour aujourd'hui, elle apparaîtra ici avec ses informations importantes.",
      },
      default: {
        title: "Vous n'avez aucune arrivée à venir",
        description:
          "Lorsque de nouvelles arrivées seront prévues, elles apparaîtront ici avec leurs informations importantes.",
      },
    },
    loading: "Chargement des réservations...",
    statuses: {
      inProgress: "En cours",
      complete: "Terminé",
      pending: "En attente",
      approved: "Approuvé",
    },
    actions: {
      replyOnWhatsApp: "Répondre sur WhatsApp",
    },
    nights: "{count} nuit | {count} nuits",
  },
  section4: {
    title: "Détail des revenus",
    total: "Revenus totaux",
    emptyChart: "Aucune donnée disponible",
    noData: "Aucune donnée de revenus à afficher",
  },
  section5: {
    title: "Revenus totaux",
    datasetLabel: "Revenus",
    filters: {
      weekly: "Hebdomadaire",
      monthly: "Mensuel",
      "6m": "6 mois",
      "12m": "12 mois",
      "24m": "24 mois",
    },
    loading: "Chargement des données...",
    errors: {
      load: "Erreur lors du chargement des données",
      connection: "Erreur de connexion",
    },
  },
  design: {
    title: `Design du panneau`,
    reorder: `Réorganiser`,
    active: `Actif`,
    theme: `Thème`,
    color: `Couleur`,
    green: `Vert`,
    system: `Système`,
    white: `Blanc`,
    sidebar: `Barre latérale`,
    black: `Noir`,
  },
  earlyCheckin: {
    earlyShort: `Tôt`,
    arrivesShort: `Arrivée`,
    arrivalAt: `À {time}`,
    requested: `Arrivée anticipée demandée`,
    arrivalRequested: `Heure d'arrivée demandée`,
  },
};
